export const ALPHABET = [
    ...Array.from(Array(23))
        .map((e, i) => i + 65)
        .map((x) => String.fromCharCode(x)),
    'XYZ',
];
